import React from 'react'
import { Link } from 'react-router-dom'

interface IStories {
  image: string
  logo?: React.ReactNode | boolean
  slogan: string
  link: string
}

export const Stories: React.FC = () => {
  const [isMobileVersion, setMobileVersion] = React.useState<boolean>()
  const handleMobileVersion = () => {
    setMobileVersion(!!window.matchMedia('(max-width: 768px)').matches)
  }
  React.useEffect(() => {
    setMobileVersion(!!window.matchMedia('(max-width: 768px)').matches)
    window.addEventListener('resize', handleMobileVersion)
    return () => {
      window.removeEventListener('resize', handleMobileVersion)
    }
  })
  const stories = getStories()
  return (
    <div className='onlinepbx__stories'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center'>
            Кейсы
          </h2>
          <div className='onlinepbx__stories__content'>
            {stories.map((story) => {
              return (
                isMobileVersion && <div className='onlinepbx__stories__block'>
                  <div className='onlinepbx__stories__image'>
                    <img src={story.image} />
                  </div>
                  <div className='onlinepbx__stories__description'>
                    <div className='onlinepbx__stories__slogan'>
                      {story.slogan}
                    </div>
                    <Link to={story.link} className='onlinepbx__stories__link'>
                      Читать историю
                    </Link>
                  </div>
                </div> ||
                <Link to={story.link} className='onlinepbx__stories__block'>
                  <div className='onlinepbx__stories__image'>
                    <img src={story.image} />
                  </div>
                  <div className='onlinepbx__stories__description'>
                    <div className='onlinepbx__stories__slogan'>
                      {story.slogan}
                    </div>
                    <div className='onlinepbx__stories__link'>
                      Читать историю
                    </div>
                  </div>
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

const getStories = (): IStories[] => {
  return [{
    image: process.env.PUBLIC_DIR + '/images/stories/story1.jpg',
    slogan: 'Автоматизируйте работу администратора и получайте на 30% лидов больше',
    link: '/stories/max_dance'
  }, {
    image: process.env.PUBLIC_DIR + '/images/stories/story2.jpg',
    slogan: 'Телефония для роста выручки барбершопов',
    link: '/stories/barbershop'
  },
  {
    image: process.env.PUBLIC_DIR + '/images/stories/story3.jpg',
    slogan: 'Фитнес-клуб Energy-Fit за счет телефонии увеличил выручку на 30%',
    link: '/stories/energy_fit'
  },
  {
    image: process.env.PUBLIC_DIR + '/images/stories/story4.jpg',
    slogan: 'Топ-4 способа использования телефонии в e-commerce',
    link: '/stories/igrolandia'
  },
  {
    image: process.env.PUBLIC_DIR + '/images/stories/story5.jpg',
    slogan: 'Как онлайн-школа использует телефонию, чтобы остаться на плаву в период резкого падения спроса',
    link: '/stories/online_school'
  }]
}

export default Stories
